import {Text} from '@mantine/core';
import React from 'react';

import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactComponent} from 'util/RootReactRender';

function AuthorizeFlow(props: {clientId: string}): JSX.Element {
  return <Text>Authorize flow for client {props.clientId}</Text>;
}

export const OAuthRoutes: RouteBundle = {
  domain: 'oauth',
  routes: [{urlPattern: 'oauth/authorize', handler: authorize}],
};

function authorize(): void {
  DatadogUtil.startRUMView('oauth_authorize');
  renderReactComponent(AuthorizeFlow);
}
